import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/logOut.tsx
var LogOut = ({ ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: /* @__PURE__ */ jsx("path", {
		d: "M11.25 20.0001H6C4.89543 20.0001 4 19.1046 4 18.0001L4 6.00006C4 4.89549 4.89543 4.00006 6 4.00006L11.25 4.00006M20 12.0001L8.75 12M20 12.0001L15.5 16.5001M20 12.0001L15.5 7.50006",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { LogOut };
